import React from "react";
import { partnerList } from "./constant";
import Image from "next/image";

const NavPartnerMenu: React.FC = () => {
    return (
        <section className="w-full mx-auto px-8 bg-white py-10 ">
            <div className="grid grid-cols-4 gap-3 max-w-7xl mx-auto px-5">
                {partnerList.map((value, idx) => (
                    <div key={idx}>
                        <div className="font-bold text-xl uppercase pb-5">{value.featureTitle}</div>
                        <hr style={{ borderTop: "1px solid #CBD5E0" }} className="w-64 pt-3" />
                        {value.feature.map((data, idx) => (
                            <div key={idx} className="pb-5">
                                {data.image && <Image alt={data.imgAlt ?? ""} src={data.image ?? ""} width={32} height={32} className="pb-3" />}
                                <div className="font-semibold text-sm pb-2 flex items-center">
                                    <a href={data.link}>{data.title}</a>
                                    {data.label && (
                                        <span className="text-xs p-1 ml-1 rounded" style={{ background: "#E5EBFF" }}>
                                            {data.label}
                                        </span>
                                    )}
                                </div>
                                <div className="text-sm">{data.summary}</div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        </section>
    );
};

export default NavPartnerMenu;
